import { Outlet } from "react-router-dom";
import Navbar from "./components/Footer";

const App: React.FC = () => {
  return (
    <div className="relative flex flex-col justify-between mx-auto min-h-screen">
      <div className="pb-20">
        <Outlet />
      </div>
      <Navbar />
    </div>
  );
};

export default App;
